import { render, staticRenderFns } from "./PendingCalls.vue?vue&type=template&id=2bd48920&scoped=true"
import script from "./PendingCalls.vue?vue&type=script&lang=js"
export * from "./PendingCalls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd48920",
  null
  
)

export default component.exports